var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOverflowVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 11,
    viewBox: "0 0 3 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01 align center"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.70413e-07 1.02588C6.45647e-07 1.59246 0.459302 2.05176 1.02588 2.05176C1.59246 2.05176 2.05176 1.59246 2.05176 1.02588C2.05176 0.459302 1.59246 -2.00767e-08 1.02588 -4.48426e-08C0.459302 -6.96084e-08 6.95179e-07 0.459302 6.70413e-07 1.02588Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.70413e-07 5.1084C6.45647e-07 5.67498 0.459302 6.13428 1.02588 6.13428C1.59246 6.13428 2.05176 5.67498 2.05176 5.1084C2.05176 4.54182 1.59246 4.08252 1.02588 4.08252C0.459302 4.08252 6.95179e-07 4.54182 6.70413e-07 5.1084Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.70413e-07 9.19067C6.45647e-07 9.75725 0.459302 10.2166 1.02588 10.2166C1.59246 10.2166 2.05176 9.75725 2.05176 9.19067C2.05176 8.6241 1.59246 8.16479 1.02588 8.16479C0.459302 8.16479 6.95179e-07 8.6241 6.70413e-07 9.19067Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverflowVertical);
export default __webpack_public_path__ + "static/media/overflow-vertical.438a9411a50d2f442c5a8a37403f7520.svg";
export { ForwardRef as ReactComponent };